import { createClient } from '../../prismicio';
import * as prismic from '@prismicio/client';

import BlogPage from '@containers/BlogPage';

const Blog = ({ pages }: any) => {
  return (
    <>
      <BlogPage pages={pages} />
    </>
  );
};

export default Blog;

/*page -> Recipe
  fusion_recipe -> Fusion Recipe
  story -> Lifestyle
  announcement -> Announcement */

export async function getStaticProps() {
  const client = createClient();
  const pages = await client.get({
    page: 1,
    pageSize: 20,
    predicates: prismic.predicate.any('document.type', [
      'page',
      'fusion_recipe',
      'story',
      'announcement',
    ]),
    orderings: { field: 'document.first_publication_date', direction: 'desc' },
  });

  return {
    props: {
      pages,
    },
  };
}
